import { cn } from "@/lib/utils";
import { OWNERS } from "@/types";

export const Eyebrow = ({ children, className }) => <p className={cn("eyebrow", className)}>{children}</p>;

export const SectionTitle = ({ eyebrow, title, right, className }) => (
  <div className={cn("flex items-end justify-between gap-3 mb-4", className)}>
    <div>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      {title && <h2 className="serif text-2xl leading-tight text-[var(--coffee)] mt-1">{title}</h2>}
    </div>
    {right}
  </div>
);

export const Field = ({ label, hint, children, className }) => (
  <label className={cn("block", className)}>
    {label && <span className="eyebrow block mb-2">{label}</span>}
    {children}
    {hint && <span className="block text-xs text-[var(--coffee-muted)] mt-1.5">{hint}</span>}
  </label>
);

export const Chips = ({ options, value, onChange, testId, className }) => (
  <div className={cn("flex flex-wrap gap-2", className)} data-testid={testId}>
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        className="chip"
        data-active={value === o.value}
        data-testid={`${testId}-${o.value}`}
        onClick={() => onChange(o.value)}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export const OwnerPicker = ({ value, onChange, testId = "owner-picker" }) => (
  <Chips options={OWNERS} value={value} onChange={onChange} testId={testId} />
);

export const OwnerTag = ({ owner }) => (
  <span
    className={cn(
      "text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded-full",
      owner === "nosso" && "bg-[var(--teal-light)] text-[var(--teal)]",
      owner === "meu" && "bg-[var(--coral-light)] text-[var(--coral)]",
      owner === "seu" && "bg-[var(--cream-surface)] text-[var(--coffee-medium)]"
    )}
  >
    {owner}
  </span>
);

export const Bar = ({ ratio, color = "var(--teal)", className }) => (
  <div className={cn("h-1.5 w-full rounded-full bg-[var(--cream-surface)] overflow-hidden", className)}>
    <div
      className="h-full rounded-full transition-[width] duration-700"
      style={{ width: `${Math.min(100, Math.round((ratio || 0) * 100))}%`, background: ratio > 1 ? "var(--coral)" : color }}
    />
  </div>
);

export const Hint = ({ children, className }) => (
  <p className={cn("text-xs leading-relaxed text-[var(--coffee-muted)] italic", className)}>{children}</p>
);
